<template>
  <div id="view-coaches-container">
    <div id="view-coaches">
      <div class="container is-fluid">
        <div class="columns coach-toolbar">
          <div class="column is-8">
            <p class="control has-icon search-container">
              <input class="input is-medium" type="text" placeholder="Procurar Coches" v-model="searchText">
              <i class="fa fa-search"></i>
            </p>
          </div>
          <div class="column is-2">
            <div class="control">
              <div class="select is-medium is-fullwidth">
                <select v-model="selectedState" :class="{ 'gray-select' : selectedState === 0 }">
                  <option class="gray-select" :value="0">Estados</option>
                  <option class="black-select" v-for="state in states" :value="state.id">{{state.name}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="column is-2"><coach-new></coach-new></div>
        </div>
      </div>
      <div class="container is-fluid">
        <div class="flexbox-grid">
          <coach-card v-for="coach in filteredCoaches" :coach="coach"></coach-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CoachNew from './CoachNew'
  import CoachCard from './CoachCard'
  import { CONTENT_STATES } from '../../config'
  
  export default {
    components: {
      CoachNew,
      CoachCard
    },

    data () {
      return {
        states: CONTENT_STATES,
        selectedState: 0,
        searchText: ''
      }
    },

    mounted () {
      this.getCoachList()
    },

    computed: {
      coaches () {
        return this.$store.state.coach.list
      },

      filteredCoaches () {
        let searchText = this.searchText
        let selectedState = this.selectedState
        let coachList = this.coaches

        if (searchText.length) {
          coachList = coachList.filter((coach) =>
            coach.languages[0].pivot.name.toLowerCase().includes(searchText.toLowerCase())
          )
        }

        if (selectedState) {
          coachList = coachList.filter((coach) =>
            parseInt(coach.state_id) === selectedState
          )
        }

        return coachList
      },

      currentEvent () {
        return window.store.state.event.nextEvent
      }
    },

    methods: {
      getCoachList () {
        this.$store.dispatch('getCoachList')
      }
    },

    watch: {
      currentEvent: function (val) {
        if (val === 'update-coach-list') {
          this.getCoachList()
        }
      }
    }
  }
</script>

<style lang="scss">
  .coach-toolbar {
    margin-bottom: 10px !important;
  }

  #view-coache-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .flexbox-grid {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  .gray-select {
    color: lightgray !important;
  }

  .gray-select {
    color: lightgray !important;
  }

  .black-select {
    color: black !important;
  }
</style>


// WEBPACK FOOTER //
// index.vue?7e8a9692